"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Core_1 = require("./Core");
class CodeInterface {
    parse_command_code(command_code) {
        let out = { etykieta: "", komenda: "", typ_atrybutu: "", wartosc_atrybutu: "" };
        if (command_code.search(/\: /) !== -1) {
            let temp;
            temp = command_code.split(/\: /);
            out.etykieta = temp[0];
            command_code = temp[1];
        }
        if (command_code.search(/ /) !== -1) {
            let temp;
            temp = command_code.split(/ /);
            out.wartosc_atrybutu = temp[1];
            command_code = temp[0];
            if (out.wartosc_atrybutu.search(/\^\d+/) !== -1) {
                out.wartosc_atrybutu = Number(out.wartosc_atrybutu.substr(1));
                out.typ_atrybutu = "pointer_to_pointer";
            }
            else if (out.wartosc_atrybutu.search(/\=\d+/) !== -1) {
                out.wartosc_atrybutu = Number(out.wartosc_atrybutu.substr(1));
                out.typ_atrybutu = "number";
            }
            else if (out.wartosc_atrybutu.search(/[a-z]+/) !== -1) {
                out.typ_atrybutu = "label";
            }
            else {
                out.wartosc_atrybutu = Number(out.wartosc_atrybutu);
                out.typ_atrybutu = "pointer";
            }
        }
        out.komenda = command_code;
        return out;
    }
    parse_code(code) {
        let commands_code = code.split("\n");
        let commands = [];
        for (var command_code of commands_code) {
            commands.push(this.parse_command_code(command_code));
        }
        return commands;
    }
    setup(code) {
        this.rm.encode(this.parse_code(code));
    }
    show() {
        console.log(this.rm.dump());
    }
    run(input) {
        return this.rm.execute(input);
    }
    constructor() {
        this.rm = new Core_1.Core;
    }
}
exports.CodeInterface = CodeInterface;
//# sourceMappingURL=CodeInterface.js.map


// WEBPACK FOOTER //
// ./utilities/RM/CodeInterface.js